function Map(args) {
    let self = {},
        priv = {};

    /* Constructor */

    priv.init = function (args) {
        /* Static properties */
        priv._offsetCellX = 32;
        priv._offsetCellY = 32;
        priv._cells = {};
        /* Set the properties */
        args = args || {};
        self.setName(args.name);
        self.setWidth(args.width);
        self.setHeight(args.height);
        self.call(args.call);
    };

    /* Public methods */

    self.call = function (callback) {
        if (typeof callback !== 'function') return;
        let obj = {};
        obj.addCell = priv.addCell.bind(this);
        callback(obj);
    };

    /* Private methods */

    priv.addCell = function (tileset, fromXY, toXYZ) {
        let index = [toXYZ[0] >> 0, toXYZ[1] >> 0, toXYZ[2] >> 0].join(';');
        priv._cells[index] = {
            source: tileset,
            tx: fromXY[0] >> 0,
            ty: fromXY[1] >> 0,
            x: toXYZ[0] >> 0,
            y: toXYZ[1] >> 0,
            z: toXYZ[2] >> 0
        };
        return this;
    };

    /* Getters */

    self.getName = function () {
        return priv._name;
    };

    self.getWidth = function () {
        return priv._width;
    };

    self.getHeight = function () {
        return priv._height;
    };

    self.getCells = function () {
        return priv._cells;
    };

    self.getOffset = function () {
        return { x: priv._offsetCellX, y: priv._offsetCellY };
    };

    /* Setters */

    self.setName = function (name) {
        return (priv._name = String(name) || ''), self;
    };

    self.setWidth = function (width) {
        return (priv._width = width >> 0 || 20), self;
    };

    self.setHeight = function (height) {
        return (priv._height = height >> 0 || 20), self;
    };

    /* Signature */
    self.constructor = { name: 'Magma.Map' };
    return priv.init(args), self;
}

export default Map;
